var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',{staticClass:"base-chip no-select",class:{ shrink: _vm.shrink },style:({
    color: '#000',
    backgroundColor: _vm.styles[(_vm.chipColor + "Background")],
    width: _vm.width
  }),attrs:{"label":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }